import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="font-hud text-[11px] uppercase tracking-[0.3em] text-volt">
        {children}
    </p>
);

export default Reveal;
